import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import {
  Box,
  Typography,
  Button,
  CircularProgress,
  Container,
} from '@mui/material';

interface Noticia {
  id: string;
  titulo: string;
  date: string;
  imagem_maior: string;
  full: string;
}

const NoticiaDetalhes: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [noticia, setNoticia] = useState<Noticia | null>(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchNoticia = async () => {
      try {
        const response = await axios.get('https://www.fecomercio-am.org.br/jsonnoticia_all.php/');
        const noticiaEncontrada = response.data.find((n: Noticia) => n.id === id);

        if (noticiaEncontrada) {
          setNoticia(noticiaEncontrada);
        } else {
          console.error('Notícia não encontrada');
        }
      } catch (error) {
        console.error('Erro ao buscar a notícia:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchNoticia();
  }, [id]);

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '80vh',
        }}
      >
        <CircularProgress sx={{ color: '#007bff' }} />
      </Box>
    );
  }

  if (!noticia) {
    return (
      <Container sx={{ textAlign: 'center', mt: 6 }}>
        <Typography variant="h6">Notícia não encontrada.</Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Button
        variant="contained"
        onClick={() => navigate(-1)}
        sx={{
          backgroundColor: '#007bff',
          mb: 3,
          '&:hover': { backgroundColor: '#0056b3' },
        }}
      >
        Voltar
      </Button>

      <Typography variant="h4" component="h1" gutterBottom sx={{ color: '#007bff' }}>
        {noticia.titulo}
      </Typography>

      <Typography variant="body2" color="text.secondary" gutterBottom>
        {noticia.date}
      </Typography>

      <Box
        component="img"
        src={
          noticia.imagem_maior
            ? `https://www.fecomercio-am.org.br/${noticia.imagem_maior}`
            : 'https://placehold.co/600x400'
        }
        onError={(e: React.SyntheticEvent<HTMLImageElement, Event>) =>
          (e.currentTarget.src = 'https://placehold.co/600x400')
        }
        alt={noticia.titulo}
        sx={{ width: '100%', borderRadius: 2, mb: 3 }}
      />

      <Box
        sx={{
          fontSize: '1rem',
          lineHeight: 1.6,
          color: '#333',
        }}
        dangerouslySetInnerHTML={{ __html: noticia.full }}
      />
    </Container>
  );
};

export default NoticiaDetalhes;
